import { useQuery } from "@tanstack/react-query";

import { getBlogListDataApi } from "@/api/end-points/blog";

export const useGetBlogList = (queryString, useQueryOptions) => {
  return useQuery({
    queryKey: ["blogs", queryString],
    queryFn: () => getBlogListDataApi(queryString),
    keepPreviousData: true,
    ...useQueryOptions,
    select: (res) => {
      return res.data?.data;
    },
  });
};
